module.exports = __webpack_public_path__ + "static/media/bgLab.91816624.png";